export const TEMPLATE_MAPPING = {
    'SOAP Adult': 'soap',
    'Psychotherapy': 'birp',
    'Intake Individual': 'intake',
    'Psychiatry Initial': 'psych_initial',
    'Psychiatry Follow-up': 'psych_followup',
  } as const;
  
  export const getTemplateId = (templateName: string): string => {
    return TEMPLATE_MAPPING[templateName as keyof typeof TEMPLATE_MAPPING] || templateName.toLowerCase().replace(/\s+/g, '_');
  };